import * as React from 'react';
import { default as BaseButton } from '../../../../BaseComponents/Button';
import { default as IconButton } from '../../../../BaseComponents/Button/components/IconButton/IconButton';
import { useTheme } from '../../../../theme';
import { useTranslation } from 'react-i18next';

interface Props {
	refusingIsInProgress: boolean;
	onInsuranceRemove: () => Promise<void>;
	closeConfirmationPopup: () => void;
}

const DialogContent: React.FunctionComponent<Props> = ({
	closeConfirmationPopup,
	onInsuranceRemove,
	refusingIsInProgress
}) => {
	const css = useTheme('AdditionalServices').Insurance;
	const { t } = useTranslation('Checkout');

	return (
		<>
			<h2 className={css.popup__title}>{t('Are you sure you are ready to remove insurance?')}</h2>

			<p className={css.popup__text}>{t('Inflight insurance or baggage insurance is your travel confidence.')}</p>

			<div className={css.popup__buttons}>
				{!refusingIsInProgress && (
					<BaseButton onClick={onInsuranceRemove} disabled={refusingIsInProgress}>
						{t('Cancel')}
					</BaseButton>
				)}

				{!refusingIsInProgress && (
					<BaseButton onClick={closeConfirmationPopup} disabled={refusingIsInProgress}>
						{t('Insure')}
					</BaseButton>
				)}

				{refusingIsInProgress && <IconButton isLoading={refusingIsInProgress} />}
			</div>
		</>
	);
};

export default DialogContent;
